
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'GooglePlay'
})
export default class GooglePlay extends Vue {}
